export default __webpack_public_path__ + "static/media/name.c012eb81.svg";